import React, { useEffect, useState } from "react";

// Semantic UI React
import {
  Menu,
  Icon,
  Segment,
  Sidebar,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Radio,
} from "semantic-ui-react";

// Styling
import "semantic-ui-css/semantic.min.css";
import "../Shared/Style.css";
import "./Style.css";

// ESRI
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import Extent from "@arcgis/core/geometry/Extent";
import Zoom from "@arcgis/core/widgets/Zoom";
import SimpleRenderer from "@arcgis/core/renderers/SimpleRenderer.js";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol.js";

// components
import ZoomWidget from "../GISMappingApp/MapComponents/ZoomWidget";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Color from "@arcgis/core/Color";

const WBGarageSale = ({ config }) => {
  const [view, setView] = useState<MapView | null>(null);
  const [filter, setFilter] = useState("all");
  const [layer, setLayer] = useState<FeatureLayer | null>(null);

  console.log("WBGarageSale", {
    // token,
    config,
    // initialExtent,
    // tabHeight,
  });

  useEffect(() => {
    let map = new Map({
      basemap: "topo-vector",
    });

    let mapView = new MapView({
      container: "map-container",
      map: map,
      center: [15, 65], // longitude, latitude
      extent: new Extent({
        spatialReference: {
          wkid: 4326,
        },
        xmax: -91.143891777,
        xmin: -91.19795329,
        ymax: 40.832753508,
        ymin: 40.809690112,
      }),
      popup: {
        dockEnabled: true,
        dockOptions: {
          buttonEnabled: true,
          breakpoint: false,
        },
      },
      highlightOptions: {
        color: new Color([40, 40, 40, 1]),
        haloOpacity: 0.9,
        fillOpacity: 0.2
      }
    });

    // mapView.popup.dockOptions = {
    //   buttonEnabled: false,
    // };
    // mapView.popup.dockEnabled = false;
    mapView.popup.highlightEnabled = true;

    mapView.when(() => {
      new Zoom({
        view: mapView,
      });

      setView(mapView);

      // view.popup.watch("selectedFeature", (selectedFeature) => {
      //   console.error({ selectedFeature });
      // });
    });

    // reactiveUtils.watch(
    //   () => mapView.popup.selectedFeature,
    //   (graphic) => {
    //     // console.log({ graphic, mapView });

    //     if (graphic) {
    //       var selected_graphic = graphic.clone();

    //       mapView.graphics.removeAll();

    //       selected_graphic.symbol = new SimpleFillSymbol({
    //         outline: {
    //           width: 3,
    //           color: [255, 0, 0, 0.8],
    //           cap: "round",
    //           join: "round",
    //         },
    //         color: new Color([26, 26, 26, 0.01]),
    //       });

    //       mapView.graphics.add(selected_graphic);
    //     }
    //   }
    // );

    // // Watch for the trigger-action event on the popup
    // reactiveUtils.on(
    //   () => mapView.popup,
    //   "trigger-action",
    //   (event) => {
    //     projection.load().then(function () {
    //       const result = projection.project(
    //         mapView.popup.location,
    //         new SpatialReference({
    //           wkid: 4326,
    //         })
    //       );

    //       window.open(
    //         // @ts-ignore
    //         `https://www.dmcgis.com/apps/pictometry/?x=${result.longitude}&y=${result.latitude}`
    //       );
    //     });
    //   }
    // );
  }, []);

  useEffect(() => {
    if (view) {
      const graphic_layer = new FeatureLayer({
        outFields: ["*"],
        source: config.sites.map((record) => {
          console.log({ record });
          return {
            geometry: {
              type: "point",
              x: record.longitude, // longitude
              y: record.latitude, // latitude
              spatialReference: {
                wkid: 4326, // WGS84 spatial reference
              },
            },
            attributes: {
              OBJECTID: record.id,
              name: record.name,
              address: record.address,
              // clothes: record.clothes ? 1 : 0,
              // electronics: record.electronics ? 1 : 0,
              // furniture: record.furniture ? 1 : 0,
              // household: record.household ? 1 : 0,
              // sports_equipment: record.sports_equipment ? 1 : 0,
              // tools: record.tools ? 1 : 0,
              // toys: record.toys ? 1 : 0,
              latitude: record.latitude,
              longitude: record.longitude,
            },
          };
        }), // array of graphics objects
        objectIdField: "OBJECTID",
        fields: [
          {
            name: "OBJECTID",
            type: "oid",
          },
          {
            name: "name",
            type: "string",
          },
          {
            name: "address",
            type: "string",
          },
          // {
          //   name: "clothes",
          //   type: "small-integer",
          // },
          // {
          //   name: "electronics",
          //   type: "small-integer",
          // },
          // {
          //   name: "furniture",
          //   type: "small-integer",
          // },
          // {
          //   name: "household",
          //   type: "small-integer",
          // },
          // {
          //   name: "sports_equipment",
          //   type: "small-integer",
          // },
          // {
          //   name: "tools",
          //   type: "small-integer",
          // },
          // {
          //   name: "toys",
          //   type: "small-integer",
          // },
          {
            name: "latitude",
            type: "double",
          },
          {
            name: "longitude",
            type: "double",
          },
        ],
        popupTemplate: {
          title: "{description}",
          content: (feature) => {
            console.log(feature);

            const attr = feature.graphic.attributes;

            return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
              <tr>
                <th>Address</th>
                <td>${attr.address}</td>
              </tr>
              
          </tbody>
          </table>
          <div class="ui divider"></div>
          <div style="width:100%;">
          <div class="ui two column grid" style="margin:0;">
            <div class="column" style="padding: 0;padding-right:0.5em">
              <a href="http://maps.google.com/maps?q=${attr.latitude},${
              attr.longitude
            }" target="_blank" class="ui tiny fluid labeled icon button">
                <i class="google icon"></i>
                Google Maps
              </a>
            </div>
            <div class="column" style="padding: 0;padding-left:0.5em">
            <a href="https://www.dmcgis.com/apps/pictometry/?x=${
              attr.longitude
            }&y=${
              attr.latitude
            }" target="_blank" class="ui tiny fluid labeled icon button">
              <i class="external icon"></i>
              Pictometry
            </a>
            </div>
            </div>
          </div>`;
          },
        },
        renderer: new SimpleRenderer({
          symbol: new SimpleMarkerSymbol({
            color: [130, 180, 120, 1],
            size: 15,
            outline: {
              width: 2,
              color: [255, 255, 255],
            },
          }),
        }),
      });

      // <tr>
      //   <th>Clothes</th>
      //   <td><i class="${
      //     attr.clothes ? "green checkmark" : "red remove"
      //   } icon "></td>
      // </tr>
      // <tr>
      // <th>Household Items</th>
      //   <td><i class="${
      //     attr.household ? "green checkmark" : "red remove"
      //   } icon "></td>
      // </tr>
      // <tr>
      //   <th>Furniture</th>
      //   <td><i class="${
      //     attr.furniture ? "green checkmark" : "red remove"
      //   } icon "></td>
      // </tr>
      // <tr>
      //   <th>Sports Equipment</th>
      //   <td><i class="${
      //     attr.sports_equipment ? "green checkmark" : "red remove"
      //   } icon "></td>
      // </tr>
      // <tr>
      //   <th>Toys</th>
      //   <td><i class="${
      //     attr.toys ? "green checkmark" : "red remove"
      //   } icon "></td>
      // </tr>
      // <tr>
      //   <th>Tools</th>
      //   <td><i class="${
      //     attr.tools ? "green checkmark" : "red remove"
      //   } icon "></td>
      // </tr>
      // <tr>
      //   <th>Electronics</th>
      //   <td><i class="${
      //     attr.electronics ? "green checkmark" : "red remove"
      //   } icon "></td>
      // </tr>

      console.log({ view });

      view.map.layers.add(graphic_layer);

      setLayer(graphic_layer);
    }
  }, [view]);

  useEffect(() => {
    if (view && layer && filter) {
      console.log({ filter: filter === "all" ? "" : `${filter} = 1` });
      layer.definitionExpression = filter === "all" ? "" : `${filter} = 1`;
    }
  }, [view, layer, filter]);

  return (
    <>
      <div id="map-container">
        <div className="top-left map-buttons">
          {view && <ZoomWidget view={view} />}
        </div>

        {/* <div className="bottom-left map-buttons">
          <Dropdown
            text="Filter"
            icon="filter"
            floating
            labeled
            button
            closeOnBlur={false}
            pointing="bottom left"
            className="icon"
            style={{ backgroundColor: "#82B478" }}
          >
            <DropdownMenu>
              <DropdownItem>
                <Radio
                  label="All"
                  name="filter"
                  checked={filter === "all"}
                  onChange={() => setFilter("all")}
                />
              </DropdownItem>
              <DropdownItem>
                <Radio
                  label="Clothes"
                  name="filter"
                  checked={filter === "clothes"}
                  onChange={() => setFilter("clothes")}
                />
              </DropdownItem>
              <DropdownItem>
                <Radio
                  label="Household Items"
                  name="filter"
                  checked={filter === "household"}
                  onChange={() => setFilter("household")}
                />
              </DropdownItem>
              <DropdownItem>
                <Radio
                  label="Furniture"
                  name="filter"
                  checked={filter === "furniture"}
                  onChange={() => setFilter("furniture")}
                />
              </DropdownItem>
              <DropdownItem>
                <Radio
                  label="Sports Equipment"
                  name="filter"
                  checked={filter === "sports_equipment"}
                  onChange={() => setFilter("sports_equipment")}
                />
              </DropdownItem>
              <DropdownItem>
                <Radio
                  label="Toys"
                  name="filter"
                  checked={filter === "toys"}
                  onChange={() => setFilter("toys")}
                />
              </DropdownItem>
              <DropdownItem>
                <Radio
                  label="Tools"
                  name="filter"
                  checked={filter === "tools"}
                  onChange={() => setFilter("tools")}
                />
              </DropdownItem>
              <DropdownItem>
                <Radio
                  label="Electronics"
                  name="filter"
                  checked={filter === "electronics"}
                  onChange={() => setFilter("electronics")}
                />
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div> */}
      </div>
    </>
  );
};

export default WBGarageSale;
